// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31tAB","rootNoMargin":"styles_rootNoMargin__313Q7"};